import React from "react";
import { Link } from "react-router-dom";
import "../styles/LearnMore.css";
import logo from "../assets/logo3.webp";
import exploreImg from "../assets/jaipur.webp"; // Add a relevant travel image

const LearnMore = () => {
  return (
    <div className="learnmore-container">
      <header className="learnmore-header over-banner">
        <div className="learnmore-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="learnmore-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="learnmore-dropdown">
            <a href="#" className="booknow-dropbtn">
              Destinations
            </a>
            <div className="learnmore-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
          <Link to="/hotels">Hotels</Link>
          <Link to="/contact-us">Contact Us</Link>
        </nav>
        <Link to="/booknow">
          <button className="learnmore-book-btn">Book Now</button>
        </Link>
      </header>

      <div className="learnmore-hero">
        <img src={exploreImg} alt="Learn More Banner" className="hero-image" />
        <div className="hero-text">
          <h1>Discover TravelKariye</h1>
          <p>
            Unforgettable journeys, handpicked destinations, and world-class
            experiences.
          </p>
        </div>
      </div>

      <section className="learnmore-content">
        <h2>About TravelKariye</h2>
        <p>
          TravelKariye.com is your one-stop destination for planning
          unforgettable journeys across India and beyond. Whether you dream of
          relaxing on a beach in Goa, exploring the royal palaces of Rajasthan,
          or trekking in the Himalayas, we bring you curated travel packages,
          hotel deals, and expert advice to make every trip seamless.
        </p>

        <h3>Why Choose Us?</h3>
        <ul>
          <li>
            <strong>Personalized Packages:</strong> Handpicked experiences
            tailored for every kind of traveler.
          </li>
          <li>
            <strong>Trusted Partners:</strong> We work with verified hotels,
            guides, and transport providers.
          </li>
          <li>
            <strong>Easy Booking:</strong> Seamless booking through our platform
            with instant confirmation.
          </li>
          <li>
            <strong>24/7 Support:</strong> Our team is available anytime during
            your journey for help or changes.
          </li>
        </ul>

        <h3>What We Offer</h3>
        <p>
          • Domestic Holiday Packages <br />
          • Hotel Bookings and Travel Deals <br />
          • Adventure Tours, Family Trips, Solo Getaways <br />• Customized
          Itineraries and Expert Travel Guidance
        </p>

        <div className="cta-section">
          <Link to="/packages" className="learnmore-btn">
            Explore Packages
          </Link>
          <Link to="/booknow" className="learnmore-btn secondary">
            Book Your Trip
          </Link>
        </div>
      </section>

      <footer className="learnmore-footer">
        <p>
          &copy; {new Date().getFullYear()} TravelKariye.com | All rights
          reserved.
        </p>
      </footer>
    </div>
  );
};

export default LearnMore;
